import { Component, OnInit, ViewChild } from '@angular/core';
import { CatalogoService } from 'src/app/services/catalogo.service';
import { UnidadResponsable } from 'src/app/models/entities/unidad-responsable';
import { RutaCatalogoEnum } from 'src/app/shared/enums/ruta-catalogo.enum';
import { take } from 'rxjs/operators';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ReportePresupuestoService } from 'src/app/services/reporte-presupuesto.service';
import { PresupuestoEstado } from 'src/app/models/entities/presupuesto-estado';
import { LotePresupuesto } from 'src/app/models/entities/lote-presupuesto';

@Component({
  selector: 'reporte-presupuestos-estados',
  templateUrl: './reporte-presupuestos-estados.component.html',
  styleUrls: ['./reporte-presupuestos-estados.component.scss']
})
export class ReportePresupuestosEstadosComponent implements OnInit {

  @ViewChild('modalPresupuestos')
  public modalPresupuestos: any;

  public catUnidadesResponsables: UnidadResponsable[] = [];
  public reporteEstadoForm: FormGroup;
  public lotesPresupuestos: LotePresupuesto[] = [];
  public presupuestosRurales: PresupuestoEstado[] = [];
  public presupuestosFederales: PresupuestoEstado[] = [];

  public readonly CAMINOS_RURALES: string = '0';
  public readonly CARRETERAS_FEDERALES: string = '1';

  constructor(
    private catalogoService: CatalogoService,
    private formBuilder: FormBuilder,
    private reportePresupuestoService: ReportePresupuestoService
  ) { }

  async ngOnInit() {
    await this.obtenerCatalogos();
    this.inicializarForm();
  }

  public async obtenerCatalogos(): Promise<any> {
    this.catUnidadesResponsables = await this.catalogoService.obtenerCatalogo<UnidadResponsable>(RutaCatalogoEnum.UNIDADES_RESPONSABLES).pipe(take(1)).toPromise();
  }

  public inicializarForm(): void {
    this.reporteEstadoForm = this.formBuilder.group({
      cveEstado: new FormControl('-1')
    });

    this.reporteEstadoForm.get('cveEstado').valueChanges.subscribe(
      async (cveEstado: string) => {
        if (cveEstado === '-1') {

        } else {
          this.lotesPresupuestos = [];
          this.presupuestosRurales = [];
          this.presupuestosFederales = [];
          this.lotesPresupuestos = await this.reportePresupuestoService.findByAnioPef(cveEstado).pipe(
            take(1)
          ).toPromise();
          for (let index = 0; index < this.lotesPresupuestos.length; index++) {
            for (let indice = 0; indice < this.lotesPresupuestos[index].lotePresupuestoEstado.presupuestosEstados.length; indice++) {
              if (this.lotesPresupuestos[index].lotePresupuestoEstado.presupuestosEstados[indice].ur === cveEstado && this.lotesPresupuestos[index].keyCatDireccionAdjunta === this.CAMINOS_RURALES) {
                this.presupuestosRurales.push(this.lotesPresupuestos[index].lotePresupuestoEstado.presupuestosEstados[indice]);
              } else if (this.lotesPresupuestos[index].lotePresupuestoEstado.presupuestosEstados[indice].ur === cveEstado && this.lotesPresupuestos[index].keyCatDireccionAdjunta === this.CARRETERAS_FEDERALES) {
                this.presupuestosFederales.push(this.lotesPresupuestos[index].lotePresupuestoEstado.presupuestosEstados[indice]);
              }
            }
          }
          let datosPresupuestos: any = [];
          datosPresupuestos.presupuestosRurales = this.presupuestosRurales;
          datosPresupuestos.presupuestosFederales = this.presupuestosFederales;
          datosPresupuestos.urEstado = {}
          datosPresupuestos.urEstado.estado = cveEstado;
          this.modalPresupuestos.abrirlModalPresupuestos(datosPresupuestos);
        }
      }
    );
  }

}
